export default {"src":"/_next/static/media/trending-up.c98efe8e.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};